import JassEnum from './enum';

/**
 * type mapvisibility
 */
export default class JassMapVisibility extends JassEnum {}
